(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-benefits-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('feature-benefits-carousel')) {
    customElements.define('feature-benefits-carousel', class extends HTMLElement {
      connectedCallback() {
        // Wait for the section's children when the editor inserts new markup.
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.events) return;
        this.track = this.querySelector('[data-fc-track]');
        if (!this.track) return;
        this.slides = Array.from(this.querySelectorAll('[data-fc-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-fc-index]'));
        this.status = this.querySelector('[data-fc-status]');
        this.index = 0;
        this.events = new AbortController();
        const options = { signal: this.events.signal };

        this.querySelectorAll('[data-fc-prev], [data-fc-next], [data-fc-dots]').forEach(el => { el.hidden = false; });
        this.querySelector('[data-fc-prev]')?.addEventListener('click', () => this.goTo(this.nearestIndex() - 1), options);
        this.querySelector('[data-fc-next]')?.addEventListener('click', () => this.goTo(this.nearestIndex() + 1), options);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i), options));
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.nearestIndex() + (event.key === 'ArrowRight' ? 1 : -1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.slides.length - 1);
          }
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.querySelectorAll('img, video').forEach(media => {
          media.addEventListener(media.tagName === 'VIDEO' ? 'loadedmetadata' : 'load', () => this.fitHeight(), options);
        });

        // Native horizontal scrolling handles touch gestures; page scrolling stays available.
        this.lastWidth = this.track.clientWidth;
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.track.clientWidth;
          if (width !== this.lastWidth) {
            this.lastWidth = width;
            this.track.scrollTo({ left: this.index * width, behavior: 'instant' });
          }
          this.fitHeight();
        });
        this.resizeObserver.observe(this.track);
        this.slides.forEach(slide => this.resizeObserver.observe(slide));

        this.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (selected >= 0) this.goTo(selected, false);
        }, options);
        this.update();
      }

      nearestIndex() {
        return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
      }

      goTo(index, animate = true) {
        const target = (index + this.slides.length) % this.slides.length;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: animate && !reducedMotion ? 'smooth' : 'instant' });
      }

      update() {
        this.index = this.nearestIndex();
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
        this.slides.forEach((slide, i) => {
          slide.setAttribute('aria-hidden', String(i !== this.index));
          slide.querySelectorAll('video').forEach(video => {
            if (i === this.index) {
              const playing = video.play();
              if (playing) playing.catch(() => {});
            } else video.pause();
          });
        });
        this.fitHeight();
        if (this.status) this.status.textContent = this.slides[this.index].getAttribute('aria-label');
      }

      fitHeight() {
        const height = this.slides[this.index]?.getBoundingClientRect().height;
        if (height > 0) this.track.style.height = `${height}px`;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.events?.abort();
        this.events = null;
        this.resizeObserver?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leak-repair-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('leak-repair-section')) {
    customElements.define(
      'leak-repair-section',
      class extends HTMLElement {

        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.init());
        }

        init() {
          if (this.controller) return;

          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];

          if (!this.track || this.slides.length < 2) return;

          this.controller = new AbortController();

          const on = (target, event, handler) => {
            if (target) {
              target.addEventListener(event, handler, {
                signal: this.controller.signal
              });
            }
          };

          this.dots = [...this.querySelectorAll('[data-dot]')];
          this.playButton = this.querySelector('[data-play]');
          this.reducedMotion = matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

          this.index = 0;
          this.visible = true;
          this.hovered = false;
          this.selected = false;
          this.dragging = false;
          this.scrolling = false;

          this.playing =
            this.dataset.autoplay === 'true' &&
            !this.reducedMotion.matches;

          this.querySelector('[data-controls]').hidden = false;

          on(
            this.querySelector('[data-prev]'),
            'click',
            () => this.go(this.index - 1)
          );

          on(
            this.querySelector('[data-next]'),
            'click',
            () => this.go(this.index + 1)
          );

          this.dots.forEach((dot, index) => {
            on(dot, 'click', () => this.go(index));
          });

          on(this.playButton, 'click', () => {
            this.playing = !this.playing;
            this.update();
          });

          on(this, 'pointerenter', (event) => {
            if (event.pointerType === 'mouse') {
              this.hovered = true;
            }
          });

          on(this, 'pointerleave', () => {
            this.hovered = false;
          });

          on(this.track, 'pointerdown', () => {
            this.dragging = true;
          });

          on(document, 'pointerup', () => {
            this.dragging = false;
          });

          on(document, 'pointercancel', () => {
            this.dragging = false;
          });

          on(this.track, 'keydown', (event) => {
            if (
              !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(
                event.key
              )
            ) {
              return;
            }

            event.preventDefault();

            let next =
              this.index +
              (event.key === 'ArrowLeft' ? -1 : 1);

            if (event.key === 'Home') {
              next = 0;
            }

            if (event.key === 'End') {
              next = this.slides.length - 1;
            }

            this.go(next);
          });

          on(this.track, 'scroll', () => {
            this.scrolling = true;
            clearTimeout(this.scrollTimer);

            this.scrollTimer = setTimeout(() => {
              this.index = this.slides.reduce(
                (best, slide, index) => {
                  const distance = Math.abs(
                    slide.offsetLeft - this.track.scrollLeft
                  );

                  const previous = Math.abs(
                    this.slides[best].offsetLeft -
                    this.track.scrollLeft
                  );

                  return distance < previous ? index : best;
                },
                0
              );

              this.scrolling = false;
              this.update();
            }, 120);
          });

          on(document, 'shopify:block:select', (event) => {
            if (
              event.detail.sectionId !== this.dataset.sectionId
            ) {
              return;
            }

            const index = this.slides.findIndex(
              slide =>
                slide.dataset.blockId === event.detail.blockId
            );

            if (index !== -1) {
              this.selected = true;
              this.go(index, false);
            }
          });

          [
            'shopify:section:select',
            'shopify:section:deselect',
            'shopify:block:deselect'
          ].forEach(eventName => {
            on(document, eventName, (event) => {
              if (
                event.detail.sectionId === this.dataset.sectionId
              ) {
                this.selected =
                  eventName === 'shopify:section:select';
              }
            });
          });

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              this.go(this.index, false);
            });

            this.resizeObserver.observe(this.track);
          }

          if ('IntersectionObserver' in window) {
            this.visibilityObserver = new IntersectionObserver(
              entries => {
                this.visible = entries[0].isIntersecting;
              }
            );

            this.visibilityObserver.observe(this.track);
          }

          if (this.dataset.autoplay === 'true') {
            this.timer = setInterval(() => {
              if (
                !this.playing ||
                this.hovered ||
                this.selected ||
                this.dragging ||
                this.scrolling ||
                !this.visible ||
                document.hidden ||
                this.matches(':focus-within') ||
                this.reducedMotion.matches
              ) {
                return;
              }

              this.go(this.index + 1);
            }, Math.max(3000, Number(this.dataset.delay) || 5000));
          }

          this.update();
        }

        go(index, animate = true) {
          this.index =
            (index + this.slides.length) % this.slides.length;

          this.track.scrollTo({
            left: this.slides[this.index].offsetLeft,
            behavior:
              animate && !this.reducedMotion.matches
                ? 'smooth'
                : 'auto'
          });

          this.update();
        }

        update() {
          this.dots.forEach((dot, index) => {
            if (index === this.index) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          this.slides.forEach((slide, index) => {
            slide.setAttribute(
              'aria-hidden',
              String(index !== this.index)
            );
          });

          if (this.playButton) {
            this.playButton.textContent =
              this.playing ? 'Pause' : 'Play';

            this.playButton.setAttribute(
              'aria-label',
              this.playing
                ? 'Pause automatic slideshow'
                : 'Start automatic slideshow'
            );
          }
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          clearInterval(this.timer);
          clearTimeout(this.scrollTimer);

          if (this.controller) {
            this.controller.abort();
          }

          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }

          if (this.visibilityObserver) {
            this.visibilityObserver.disconnect();
          }

          this.controller = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outdoor-radio-versatility"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'outdoor-radio-carousel';
  if (customElements.get(tag)) return;
  class OutdoorRadioCarousel extends HTMLElement {
    connectedCallback() { this.boot = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() { this.destroy(); }
    init() {
      const active = this.slides?.[this.index]?.dataset.blockId;
      this.destroy();
      if (!this.isConnected || !(this.track = this.querySelector('[data-track]'))) return;
      this.slides = [...this.track.children].filter(el => el.matches('[data-slide]:not([data-clone])'));
      this.dataset.count = String(this.slides.length);
      this.index = Math.max(0, this.slides.findIndex(el => el.dataset.blockId === active));
      this.queue = 0; this.moving = false; this.touching = false;
      this.controller = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const on = (el, type, fn, opts = {}) => el?.addEventListener(type, fn, { ...opts, signal: this.controller.signal });
      this.buttons = [this.querySelector('[data-prev]'), this.querySelector('[data-next]')];
      this.status = this.querySelector('[data-status]');
      this.setupAuto(on);
      if (!this.track.hasAttribute('tabindex')) this.track.tabIndex = 0;
      if (this.slides.length > 1) {
        const clone = slide => {
          const copy = slide.cloneNode(true);
          for (const el of [copy, ...copy.querySelectorAll('*')]) {
            for (const attr of [...el.attributes]) {
              if (attr.name === 'id' || attr.name === 'data-block-id' || attr.name.startsWith('data-shopify-')) el.removeAttribute(attr.name);
            }
          }
          copy.dataset.clone = ''; copy.setAttribute('aria-hidden', 'true'); copy.setAttribute('inert', '');
          return copy;
        };
        this.track.prepend(...this.slides.map(clone));
        this.track.append(...this.slides.map(clone));
      }
      on(this.buttons[0], 'click', () => this.move(-1));
      on(this.buttons[1], 'click', () => this.move(1));
      on(this, 'keydown', event => {
        if (!this.can || event.target.matches('input, textarea, select, [contenteditable]')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      on(this.track, 'scroll', () => { clearTimeout(this.autoTimer); this.schedule(); }, { passive: true });
      on(this.track, 'pointerdown', event => this.startDrag(event));
      on(this.track, 'pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        this.track.scrollLeft = this.drag.left + this.drag.x - event.clientX;
        event.preventDefault();
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => on(this.track, type, event => this.endDrag(event)));
      on(this.track, 'touchstart', () => {
        this.touching = true; this.queue = 0; this.moving = false; clearTimeout(this.timer); this.arm();
      }, { passive: true });
      ['touchend', 'touchcancel'].forEach(type => on(this.track, type, event => {
        this.touching = event.touches.length > 0; this.schedule();
      }, { passive: true }));
      if (this.dataset.designMode === 'true') on(this, 'shopify:block:select', event => {
        const index = this.slides.findIndex(el => el.dataset.blockId === event.detail?.blockId || el.contains(event.target));
        if (index >= 0) { this.queue = 0; this.go(index, false); }
      });
      this.mutations = new MutationObserver(records => {
        const changed = records.some(record => [...record.addedNodes, ...record.removedNodes]
          .some(node => node.nodeType === 1 && node.matches('[data-slide]:not([data-clone])')));
        if (changed) { cancelAnimationFrame(this.boot); this.boot = requestAnimationFrame(() => this.init()); }
      });
      this.mutations.observe(this.track, { childList: true });
      if (typeof ResizeObserver !== 'undefined') {
        this.resize = new ResizeObserver(() => this.measure());
        this.resize.observe(this.track);
        if (this.slides[0]) this.resize.observe(this.slides[0]);
      } else on(window, 'resize', () => this.measure());
      this.measure();
    }
    setupAuto(on) {
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Math.max(2, Math.min(10, Number(this.dataset.interval) || 4)) * 1000;
      this.paused ??= false; this.hovered = matchMedia('(hover: hover)').matches && this.matches(':hover'); this.focused = this.contains(document.activeElement);
      this.visible = typeof IntersectionObserver === 'undefined'; this.play = this.querySelector('[data-play]');
      on(this.play, 'click', () => { this.paused = !this.paused; this.arm(); });
      if (!this.autoplay) return;
      on(document, 'visibilitychange', () => this.arm());
      on(this.reduced, 'change', () => this.arm());
      on(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.arm(); } });
      on(this, 'pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.arm(); } });
      on(this, 'focusin', () => { this.focused = true; this.arm(); });
      on(this, 'focusout', event => { this.focused = this.contains(event.relatedTarget); this.arm(); });
      if (!this.visible) {
        this.viewport = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.arm(); });
        this.viewport.observe(this.track);
      }
    }
    autoAllowed() {
      return this.isConnected && this.can && this.autoplay && !this.paused && this.visible && !document.hidden
        && !this.hovered && !this.focused && !this.touching && !this.drag && !this.moving
        && !this.reduced.matches && this.dataset.designMode !== 'true';
    }
    arm() {
      clearTimeout(this.autoTimer);
      if (this.play) {
        this.play.hidden = !this.autoplay || !this.can || this.reduced.matches || this.dataset.designMode === 'true'; this.play.disabled = this.play.hidden;
        this.play.setAttribute('aria-pressed', String(this.paused));
        const key = this.paused ? 'playLabel' : 'pauseLabel';
        this.play.setAttribute('aria-label', this.play.dataset[key] ?? this.dataset[key] ?? (this.paused ? 'Play slideshow' : 'Pause slideshow'));
      }
      this.status?.setAttribute('aria-live', this.autoplay && !this.paused && !this.hovered && !this.focused && !this.touching && !this.reduced?.matches && this.dataset.designMode !== 'true' ? 'off' : 'polite');
      if (this.autoAllowed()) this.autoTimer = setTimeout(() => { if (this.autoAllowed()) this.move(1); }, this.interval);
    }
    measure() {
      if (!this.track) return;
      const first = this.slides[0]?.getBoundingClientRect();
      const step = this.slides[1] ? this.slides[1].getBoundingClientRect().left - first.left : 0;
      const origin = first ? first.left - this.track.getBoundingClientRect().left - this.track.clientLeft + this.track.scrollLeft : 0;
      const changed = !Number.isFinite(this.step) || Math.abs(step - this.step) > 0.1 || Math.abs(origin - this.origin) > 0.1;
      this.step = step; this.origin = origin;
      // Surrounding copies provide a full cycle in either direction.
      this.can = this.slides.length > 1 && step > 0 && this.track.scrollWidth > this.track.clientWidth + 1;
      this.buttons.forEach(button => { if (button) { button.hidden = !this.can; button.disabled = !this.can; } });
      if (changed && this.can) { this.queue = 0; this.moving = false; this.jump(origin + this.index * step); }
      this.announce(); this.arm();
    }
    announce() {
      if (!this.status || !this.slides.length) return;
      const text = `${this.dataset.slideLabel ?? 'Slide'} ${this.index + 1} ${this.dataset.ofLabel ?? 'of'} ${this.slides.length}`;
      if (this.status.textContent !== text) this.status.textContent = text;
    }
    schedule() { clearTimeout(this.timer); this.timer = setTimeout(() => this.finish(), 150); }
    jump(left) {
      const snap = this.track.style.scrollSnapType, behavior = this.track.style.scrollBehavior;
      this.track.style.scrollSnapType = 'none'; this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = left;
      this.track.style.scrollSnapType = snap; this.track.style.scrollBehavior = behavior;
    }
    go(index, animate = true) {
      if (!this.can) return;
      this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.moving = true; this.arm();
      const left = this.origin + index * this.step;
      if (animate && !this.reduced.matches) this.track.scrollTo({ left, behavior: 'smooth' });
      else this.jump(left);
      this.schedule();
    }
    move(delta) {
      if (!this.can) return;
      clearTimeout(this.autoTimer);
      if (this.moving) { this.queue += delta; return; }
      this.finish(false); this.go(this.index + delta);
    }
    finish(drain = true) {
      if (!this.can || this.drag || this.touching) return;
      clearTimeout(this.timer);
      const raw = Math.round((this.track.scrollLeft - this.origin) / this.step), count = this.slides.length;
      this.index = ((raw % count) + count) % count;
      const left = this.origin + this.index * this.step;
      if (Math.abs(this.track.scrollLeft - left) > 0.5) this.jump(left);
      this.moving = false; this.announce();
      if (drain && this.queue) { const delta = Math.sign(this.queue); this.queue -= delta; this.go(this.index + delta); }
      this.arm();
    }
    startDrag(event) {
      if (!this.can || event.pointerType !== 'mouse' || event.button !== 0) return;
      this.queue = 0; this.moving = false; clearTimeout(this.timer);
      this.track.setAttribute('data-dragging', ''); this.jump(this.track.scrollLeft);
      this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft }; this.arm();
      this.track.setPointerCapture(event.pointerId); event.preventDefault();
    }
    endDrag(event) {
      if (!this.drag || event.pointerId !== this.drag.id) return;
      const id = this.drag.id; this.drag = null;
      this.track.removeAttribute('data-dragging');
      if (this.track.hasPointerCapture(id)) this.track.releasePointerCapture(id);
      this.go(Math.round((this.track.scrollLeft - this.origin) / this.step));
    }
    destroy() {
      cancelAnimationFrame(this.boot); clearTimeout(this.timer); clearTimeout(this.autoTimer);
      this.controller?.abort(); this.resize?.disconnect(); this.mutations?.disconnect(); this.viewport?.disconnect();
      if (this.track) {
        if (this.drag && this.track.hasPointerCapture(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
        this.track.removeAttribute('data-dragging');
        this.track.querySelectorAll('[data-clone]').forEach(el => el.remove());
      }
      this.drag = null; this.track = null; this.step = undefined; this.can = false;
    }
  }
  customElements.define(tag, OutdoorRadioCarousel);
  ['load', 'unload'].forEach(type => document.addEventListener(`shopify:section:${type}`, event => {
    event.target.querySelectorAll(tag).forEach(el => type === 'load' ? el.init() : el.destroy());
  }));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-hair-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pet-hair-faq')) {
  customElements.define('pet-hair-faq', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      if (!this.isConnected || this.ready) return;
      this.ready = true;
      this.rows = Array.from(this.querySelectorAll('.pf-row'));
      this.animations = new Map();
      this.rows.forEach(row => {
        row.dataset.expanded = String(row.open);
        row.querySelector('.pf-summary').setAttribute('aria-expanded', String(row.open));
      });

      this.onClick = event => {
        const summary = event.target.closest('.pf-summary');
        if (!summary || summary.closest('pet-hair-faq') !== this) return;
        const row = summary.parentElement;
        event.preventDefault();
        this.openRow(row, row.dataset.expanded !== 'true');
      };
      this.onToggle = event => {
        const row = event.target;
        if (!this.rows.includes(row) || this.animations.has(row)) return;
        // Preserve native keyboard and programmatic details behavior.
        const expanded = row.open;
        row.dataset.expanded = String(expanded);
        row.querySelector('.pf-summary').setAttribute('aria-expanded', String(expanded));
        if (expanded) this.rows.forEach(other => {
          if (other !== row && other.dataset.expanded === 'true') this.setOpen(other, false);
        });
      };
      this.onBlockSelect = event => {
        const row = this.rows.find(item => item.dataset.blockId === event.detail?.blockId);
        if (row) this.openRow(row, true, false);
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('toggle', this.onToggle, true);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    openRow(row, expanded, animate = true) {
      if (expanded) this.rows.forEach(other => {
        if (other !== row && other.dataset.expanded === 'true') this.setOpen(other, false, animate);
      });
      this.setOpen(row, expanded, animate);
    }

    setOpen(row, expanded, animate = true) {
      const summary = row.querySelector('.pf-summary');
      const start = row.getBoundingClientRect().height;
      const previous = this.animations.get(row);
      if (previous) {
        previous.onfinish = null;
        previous.cancel();
        this.animations.delete(row);
      }
      row.style.overflow = '';
      row.dataset.expanded = String(expanded);
      summary.setAttribute('aria-expanded', String(expanded));
      const canAnimate = animate && this.dataset.animate === 'true' &&
        typeof row.animate === 'function' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!canAnimate) {
        row.open = expanded;
        return;
      }

      row.open = true;
      const border = parseFloat(getComputedStyle(row).borderBottomWidth) || 0;
      const end = expanded ? row.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
      if (Math.abs(start - end) < 1) {
        row.open = expanded;
        return;
      }
      row.style.overflow = 'hidden';
      const animation = row.animate(
        [{ height: `${start}px` }, { height: `${end}px` }],
        { duration: 400, easing: 'ease-in-out' }
      );
      this.animations.set(row, animation);
      animation.onfinish = () => {
        if (this.animations.get(row) !== animation) return;
        row.open = expanded;
        row.style.overflow = '';
        this.animations.delete(row);
      };
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      if (!this.ready) return;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('toggle', this.onToggle, true);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.animations.forEach((animation, row) => {
        animation.onfinish = null;
        animation.cancel();
        row.open = row.dataset.expanded === 'true';
        row.style.overflow = '';
      });
      this.animations.clear();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radio-charging"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('radio-charging')) {
  customElements.define('radio-charging', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.onResize = () => this.updateVideo();
      this.onVisibility = () => { if (document.hidden) this.video.pause(); else this.updateVideo(); };
      this.onMotion = () => { this.video.pause(); this.updateVideo(); };
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.updateVideo(); else this.video.pause();
      }, { rootMargin: '100px' });
      this.intersectionObserver.observe(this);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.motion.addEventListener('change', this.onMotion);
    }
    updateVideo() {
      if (!this.visible || !this.isConnected) return;
      const mobile = this.getBoundingClientRect().width <= 1080;
      const src = mobile ? this.video.dataset.mobile : this.video.dataset.desktop;
      const poster = mobile ? this.video.dataset.posterMobile : this.video.dataset.posterDesktop;
      if (poster) this.video.setAttribute('poster', poster); else this.video.removeAttribute('poster');
      if (!src) { this.video.pause(); this.video.removeAttribute('src'); return; }
      const changed = this.video.getAttribute('src') !== src;
      if (changed) { this.video.pause(); this.video.src = src; this.video.load(); }
      if (this.dataset.autoplay === 'true' && !this.motion.matches && !document.hidden) this.video.play().catch(() => {});
    }
    disconnectedCallback() {
      this.video?.pause();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.motion?.removeEventListener('change', this.onMotion);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radio-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('radio-faq')) {
    customElements.define('radio-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.items = Array.from(this.querySelectorAll('.rf-item'));
        this.items.forEach(item => {
          item.querySelector('summary').addEventListener('click', () => {
            if (!item.open) this.closeOthers(item);
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.rf-item');
          if (item && this.contains(item)) { this.closeOthers(item); item.open = true; }
        }, options);
        this.addEventListener('click', event => {
          const link = event.target.closest('.rf-cta');
          if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#') || href.length < 2) return;
          let target;
          try { target = document.getElementById(decodeURIComponent(href.slice(1))); } catch (_) { return; }
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        }, options);
      }
      closeOthers(current) { this.items.forEach(item => { if (item !== current) item.open = false; }); }
      disconnectedCallback() { this.events?.abort(); this.events = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restored-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restored-comparison')) {
    customElements.define('restored-comparison', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        this.pointer = null;
      }

      initialize() {
        if (this.events) this.events.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.track = this.querySelector('[data-rc-track]');
        this.slides = Array.from(this.querySelectorAll('[data-rc-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-rc-go]'));
        this.status = this.querySelector('[data-rc-status]');
        this.index = Math.max(0, Math.min(this.index || 0, this.slides.length - 1));
        if (!this.track || !this.slides.length) return;

        this.querySelector('[data-rc-prev]').addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-rc-next]').addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.go(index), options);
        });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);

        this.track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        this.track.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0 || this.slides.length < 2) return;
          this.pointer = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            slide: this.slides.indexOf(event.target.closest('[data-rc-slide]'))
          };
          this.track.setPointerCapture(event.pointerId);
        }, options);

        this.track.addEventListener('pointerup', (event) => {
          const start = this.pointer;
          if (!start || start.id !== event.pointerId) return;
          this.pointer = null;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.go(this.index + (dx < 0 ? 1 : -1));
          } else if (Math.abs(dx) < 12 && Math.abs(dy) < 12 && start.slide >= 0) {
            this.go(start.slide);
          }
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        }, options);

        this.track.addEventListener('pointercancel', () => { this.pointer = null; }, options);
        this.track.addEventListener('lostpointercapture', () => { this.pointer = null; }, options);

        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) this.go(selected);
        }, options);

        this.go(this.index, false);
        this.classList.add('is-ready');
      }

      go(index, announce = true) {
        const count = this.slides.length;
        if (!count) return;
        this.index = ((index % count) + count) % count;

        this.slides.forEach((slide, position) => {
          let offset = (position - this.index + count) % count;
          if (offset > count / 2) offset -= count;
          const active = offset === 0;
          slide.style.setProperty('--rc-shift', (offset * 85) + '%');
          slide.style.setProperty('--rc-scale', active ? '1' : '0.8');
          slide.style.zIndex = active ? '10' : '1';
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-neighbor', Math.abs(offset) === 1);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        this.dots.forEach((dot, position) => {
          dot.setAttribute('aria-current', position === this.index ? 'true' : 'false');
        });
        if (announce && this.status) {
          this.status.textContent = 'Comparison ' + (this.index + 1) + ' of ' + count;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rust-repair-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rust-repair-faq')) {
    customElements.define('rust-repair-faq', class extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify || !window.Shopify.designMode || this.onBlockSelect) return;
        this.onBlockSelect = (event) => {
          const item = event.target.closest('details.rf-item');
          if (item && this.contains(item)) item.open = true;
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        if (!this.onBlockSelect) return;
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.onBlockSelect = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salon-results-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('salon-results-section')) {
    customElements.define('salon-results-section', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.scrollFrame);
        if (this.events) this.events.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      initialize() {
        if (this.events) this.events.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.track = this.querySelector('[data-sr-track]');
        this.slides = Array.from(this.querySelectorAll('[data-sr-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-sr-dot]'));
        this.status = this.querySelector('[data-sr-status]');
        this.index = Math.max(0, Math.min(this.index || 0, this.slides.length - 1));

        this.querySelectorAll('[data-sr-range]').forEach((range) => {
          const update = () => {
            const value = Math.max(0, Math.min(100, Number(range.value)));
            range.closest('[data-sr-slide]').style.setProperty('--sr-position', value + '%');
            range.setAttribute('aria-valuetext', range.dataset.beforeLabel + ' ' + value + '%, ' + range.dataset.afterLabel + ' ' + (100 - value) + '%');
          };
          update();
          range.addEventListener('input', update, options);
        });
        if (!this.track || !this.slides.length) return;

        this.querySelector('[data-sr-prev]').addEventListener('click', () => this.navigate(this.index - 1), options);
        this.querySelector('[data-sr-next]').addEventListener('click', () => this.navigate(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.navigate(index), options));

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            const origin = this.slides[0].offsetLeft;
            let nearest = 0;
            let distance = Infinity;
            this.slides.forEach((slide, index) => {
              const delta = Math.abs(slide.offsetLeft - origin - this.track.scrollLeft);
              if (delta < distance) { distance = delta; nearest = index; }
            });
            this.updateNavigation(nearest, false);
          });
        }, { ...options, passive: true });

        this.track.addEventListener('focusin', (event) => {
          const slide = event.target.closest('[data-sr-slide]');
          const index = this.slides.indexOf(slide);
          if (index >= 0 && index !== this.index) this.navigate(index, false, false);
        }, options);

        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.navigate(index, false);
        }, options);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.navigate(this.index, false, false));
          this.resizeObserver.observe(this.track);
        }
        this.navigate(this.index, false, false);
        this.classList.add('is-ready');
      }

      navigate(index, smooth = true, announce = true) {
        const count = this.slides.length;
        if (!count) return;
        const target = ((index % count) + count) % count;
        const left = this.slides[target].offsetLeft - this.slides[0].offsetLeft;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left, behavior: smooth && !reduced ? 'smooth' : 'auto' });
        this.updateNavigation(target, announce);
      }

      updateNavigation(index, announce) {
        this.index = index;
        this.dots.forEach((dot, position) => dot.setAttribute('aria-current', position === index ? 'true' : 'false'));
        if (announce && this.status) {
          this.status.textContent = 'Comparison ' + (index + 1) + ' of ' + this.slides.length;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
